import React from "react";

interface GradientSpinnerProps {
    size?: number;
    strokeWidth?: number;
}

const GradientSpinner: React.FC<GradientSpinnerProps> = ({size = 50, strokeWidth = 15}) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    return (
        <svg
            width={size}
            height={size}
            className="animate-spin"
            viewBox={`0 0 ${size} ${size}`}
        >
            <defs>
                <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#06065C"/>
                    <stop offset="40%" stopColor="#090317"/>
                    <stop offset="100%" stopColor="#4E5882"/>
                </linearGradient>
            </defs>
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                fill="transparent"
                stroke="url(#grad)"
                strokeWidth={strokeWidth}
                strokeDasharray={circumference}
                strokeDashoffset={circumference * 0.25}
                strokeLinecap="round"
            />
        </svg>
    );
};

export default GradientSpinner;